const css = `.copy-hours-dialog {
  width: 90vw;
  max-width: 500px;
}
.copy-hours-dialog .copy-hours-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.copy-hours-dialog .copy-hours-content .dialog-message {
  color: var(--text-muted);
  margin: 0;
}
.copy-hours-dialog .copy-hours-content .copy-options .copy-options-label {
  font-weight: var(--font-weight-semibold);
  margin-bottom: 12px;
  color: var(--text);
}
.copy-hours-dialog .copy-hours-content .copy-options .options-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.copy-hours-dialog .copy-hours-content .copy-options .options-container .p-field-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}
.copy-hours-dialog .copy-hours-content .copy-options .options-container .p-field-checkbox label {
  margin: 0;
  cursor: pointer;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  color: var(--text);
}

@media (max-width: 768px) {
  .copy-hours-dialog {
    width: 100vw;
    height: 100vh;
    margin: 0;
  }
  .copy-hours-dialog .p-dialog-content {
    padding: 16px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvQ29weUhvdXJzRGlhbG9nIiwic291cmNlcyI6WyJDb3B5SG91cnNEaWFsb2cuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7O0FBRUE7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOztBQUlBO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7O0FBUVo7RUFDRTtJQUNFO0lBQ0E7SUFDQTs7RUFFQTtJQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmNvcHktaG91cnMtZGlhbG9nIHtcbiAgd2lkdGg6IDkwdnc7XG4gIG1heC13aWR0aDogNTAwcHg7XG5cbiAgLmNvcHktaG91cnMtY29udGVudCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgIGdhcDogMjRweDtcblxuICAgIC5kaWFsb2ctbWVzc2FnZSB7XG4gICAgICBjb2xvcjogdmFyKC0tdGV4dC1tdXRlZCk7XG4gICAgICBtYXJnaW46IDA7XG4gICAgfVxuXG4gICAgLmNvcHktb3B0aW9ucyB7XG4gICAgICAuY29weS1vcHRpb25zLWxhYmVsIHtcbiAgICAgICAgZm9udC13ZWlnaHQ6IHZhcigtLWZvbnQtd2VpZ2h0LXNlbWlib2xkKTtcbiAgICAgICAgbWFyZ2luLWJvdHRvbTogMTJweDtcbiAgICAgICAgY29sb3I6IHZhcigtLXRleHQpO1xuICAgICAgfVxuXG4gICAgICAub3B0aW9ucy1jb250YWluZXIge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICAgICAgICBnYXA6IDE2cHg7XG5cbiAgICAgICAgLnAtZmllbGQtY2hlY2tib3gge1xuICAgICAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgICBnYXA6IDhweDtcblxuICAgICAgICAgIGxhYmVsIHtcbiAgICAgICAgICAgIG1hcmdpbjogMDtcbiAgICAgICAgICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICAgICAgICAgIGZvbnQtd2VpZ2h0OiB2YXIoLS1mb250LXdlaWdodC1yZWd1bGFyKTtcbiAgICAgICAgICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLXNtKTtcbiAgICAgICAgICAgIGNvbG9yOiB2YXIoLS10ZXh0KTtcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2OHB4KSB7XG4gIC5jb3B5LWhvdXJzLWRpYWxvZyB7XG4gICAgd2lkdGg6IDEwMHZ3O1xuICAgIGhlaWdodDogMTAwdmg7XG4gICAgbWFyZ2luOiAwO1xuXG4gICAgLnAtZGlhbG9nLWNvbnRlbnQge1xuICAgICAgcGFkZGluZzogMTZweDtcbiAgICB9XG4gIH1cbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
